import React from "react";
import "./index.less";

const Page1: React.FC = () => {
  return (
    <section className="page1">
      <section className="info">
        <div className="addr">
          住所: 〒104-0061 東京都中央區銀座7-17-18 ジュエル銀座1F
        </div>
        <div>予約電話: 03-6278-8839</div>
      </section>
      <section className="info">
        <div>
          予約URL:{" "}
          <a
            className="link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.tablecheck.com/shops/ginza-seven/reserve"
          >
            www.tablecheck.com/shops/ginza-seven/reserve
          </a>
        </div>
      </section>
      <div className="title">銀座七號</div>
      <div className="text">
        日本の四季折々の食材を巧みに活かし、上海料理と広東料理の技法を駆使して、繊細かつ豪華な一皿をお届けします。
      </div>
    </section>
  );
};

export default Page1;
